import React from "react";
import "../../../styles/component/common/page-header.scss"
import Breadcrumb from "../breadcrumb/breadcrumb";
import type {BreadcrumbProps} from "../breadcrumb/breadcrumb";


export interface PageHeaderProps {
    title: string;
    description?: string;
    actions?: React.ReactNode;
    breadcrumb?: BreadcrumbProps;
}

function PageHeader(props: PageHeaderProps) {
    return (
        <div className="pn__page-header">

            {/* ----- Breadcrumb ----- */}
            {props.breadcrumb?.data && (
                <Breadcrumb data={props.breadcrumb.data} size={props.breadcrumb.size}/>
            )}

            <div className="pn__page-header__row">
                <div>
                    <h2 className="pn__page-header__title">
                        {props.title}
                    </h2>
                    {props.description && <p className="pn__page-header__description">{props.description}</p>}
                </div>
                {
                    props.actions &&
                    <div className="pn__page-header__actions">
                        {props.actions}
                    </div>
                }

            </div>
        </div>
    )
}

export default PageHeader;